import { isUndefined } from "../../util/TypeUtil";
import Content from "./Content";
import ContentTypes from "./ContentTypes";

/**
* NarrativeEventContent.js
* 
* Created on 16-jul-2014, 14:36:24
*
* @author Ruud Schop for Ranj
**/
export default class NarrativeEventContent extends Content {
    constructor(languagePack, contentID, label) {

        isUndefined(contentID) ? contentID = null : null;
        isUndefined(label) ? label = null : null;
        isUndefined(label) ? label = null : null;

        super(NarrativeEventContent.NAME, NarrativeEventContent.TYPE, label, languagePack, contentID, true, true);
        this.type = ContentTypes.TYPE_NARRATIVE_EVENT;
    }

    setEventName(eventName) {
        // SM: Temp return. The story currently contains the event description in the JSON which overwrites the LP this way...
        return;

        if (this.getEventDescription() !== eventName) {
            this.setLanguagePackText(NarrativeEventContent.EVENT_NAME_LABEL, eventName);
        }
    }

    getEventName() {
        return this.getLanguagePackText(NarrativeEventContent.EVENT_NAME_LABEL);
    }

    setEventType(eventType) {
        this.eventType = eventType;
    }

    getEventType() {
        return this.eventType;
    }

    setLabel(label) {
        this.label = label;
    }

    getLabel() {
        return this.label;
    }

    setEventDescription(description) {
        // SM: Temp return. The story currently contains the event description in the JSON which overwrites the LP this way...
        return;

        if (this.getEventDescription() !== description) {
            this.setLanguagePackText(NarrativeEventContent.EVENT_DESCRIPTION_LABEL, description);
        }
    }

    getEventDescription() {
        return this.getLanguagePackText(NarrativeEventContent.EVENT_DESCRIPTION_LABEL);
    }

    setType(type) {
        this.type = type;
    }

    getType() {
        return this.type;
    }

    setImage(value) {
        this._image = value;
    }

    getImage() {
        return this._image;
    }

    setMovie(value) {
        this._movie = value;
    }

    getMovie() {
        return this._movie;
    }

    convertToObject() {
        // TODO
        return this.getObject(["eventType", "image", "movie", "type"]);
    }
}

NarrativeEventContent.NAME = "Narrative Event";
NarrativeEventContent.TYPE = ContentTypes.TYPE_NARRATIVE_EVENT;
NarrativeEventContent.EVENT_NAME_LABEL = "eventName";
NarrativeEventContent.EVENT_DESCRIPTION_LABEL = "eventDescription";

